export const MIN_EXCERPT_LENGTH = 10;
export const MAX_EXCERPT_LENGTH = 100;
export const DEFAULT_EXCERPT_LENGTH = 55;
